/* istanbul ignore file */
import styled from 'styled-components';

export const InvisibleButton = styled.button`
  padding: 5px;
  border-radius: 4px;
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

export const AccessibilityFormButton = styled.button`
  visibility: hidden;
  position: absolute;
`;
